import React, { useEffect, useRef, useState } from "react";
import { Keyboard, StyleSheet, Text, View } from "react-native";
import { GooglePlacesAutocomplete } from "react-native-google-places-autocomplete";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import useLocation from "../hooks/useLocation";
import {
  LATITUDE_DELTA,
  LONGITUDE_DELTA,
  googleMapsAPIKey,
} from "../services/Config";
import * as Colors from "../styles/colors";

export default function GooglePlacesInput({
  setMarker,
  setLoading,
  setRadiosCircle,
}) {
  const ref = useRef();
  const [address, setAdress] = useState(null);
  const deviceLocation = useLocation();

  useEffect(() => {
    if (address) ref.current?.setAddressText(address);
  }, [address]);

  const onGetPosition = () => {
    if (!!address) {
      setAdress(null);
      ref.current?.setAddressText("");
    }
    setMarker({
      ...deviceLocation,
      latitudeDelta: 0.032,
      longitudeDelta: 0.019,
    });
  };

  return (
    <GooglePlacesAutocomplete
      placeholder="Digite um lugar"
      onPress={(data, details) => {
        setMarker({
          latitude: details.geometry.location.lat,
          longitude: details.geometry.location.lng,
          latitudeDelta: LATITUDE_DELTA,
          longitudeDelta: LONGITUDE_DELTA,
        });
        setRadiosCircle(3000);
        setAdress(details.formatted_address);
      }}
      textInputProps={{
        placeholderTextColor: Colors.GRAY_DARK,
      }}
      ref={ref}
      query={{
        key: googleMapsAPIKey,
        language: "pt-BR",
        components: "country:br",
        fields: "geometry",
      }}
      renderRightButton={() => (
        <>
          <Icon
            style={[styles.icon, { right: 35 }]}
            name={"crosshairs-gps"}
            size={27}
            color={Colors.WELCOME_TEXT}
            onPress={() => {
              onGetPosition();
            }}
          />

          <Icon
            style={styles.icon}
            name={"close-circle-outline"}
            size={27}
            color={Colors.WELCOME_TEXT}
            onPress={() => {
              Keyboard.dismiss();
              ref.current?.clear();
            }}
          />
        </>
      )}
      styles={searchInputStyle}
      fetchDetails={true}
      minLength={3}
      listEmptyComponent={() => (
        <View style={{ flex: 1 }}>
          <Text>Nenhum resultado encontrado</Text>
        </View>
      )}
    />
  );
}

const searchInputStyle = {
  container: {
    backgroundColor: "#fff",
    // marginLeft: 8,
    // marginRight: 16,
    // marginTop: 16,
    marginBottom: 0,
    opacity: 0.9,
    borderRadius: 8,
  },
  description: {
    borderTopWidth: 0,
    borderBottomWidth: 0,
    opacity: 0.9,
  },
  predefinedPlacesDescription: {
    color: "#355",
  },
  textInputContainer: {
    height: 50,
  },

  textInput: {
    backgroundColor: Colors.WHITE,
    borderColor: Colors.BLACK,
    borderRadius: 8,
    height: 55,
    alignItems: "flex-start",
    justifyContent: "center",
    borderWidth: 1,
  },
};

const styles = StyleSheet.create({
  icon: {
    position: "absolute",
    right: 5,
    marginTop: 12,
    alignItems: "center",
    justifyContent: "center",
  },
});
